import merge from 'lodash-es/merge';
import { ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../../util';
import { TBuildStateObject } from '../types';

/**
 * Dado un estado, se devuelven las propiedades necesarias para garantizar que
 * dicho estado se aplique en variadas circunstancias.
 */
const buildStateObject: TBuildStateObject = (props, state) => {
  switch (state) {
    case 'active':
      return {
        '&:active': props,
        'input[role]:active ~ &': props,
        'input[role]:active ~ & path': props,
      };
    case 'checked':
      return {
        '&:checked': props,
        'input[role]:checked ~ &': props,
        'input[role]:checked ~ & path': props,
      };
    case 'disabled':
      return {
        '&:disabled': props,
        'input[role]:disabled ~ &': props,
        'input[role]:disabled ~ & path': props,
      };
    case 'focus': {
      const focusObject = merge({}, focusOutline, props);
      return {
        '&:focus': focusObject,
        'input[role]:focus ~ &': focusObject,
      };
    }
    case 'hover': {
      return {
        '&:hover:not([readonly], :disabled,[aria-selected="true"],:active)':
          props,
        'input[role]:hover:not([readonly], :active, :disabled) ~ &:not(:disabled,[aria-selected="true"])':
          props,
        'input[role]:hover:not([readonly], :active, :disabled) ~ &:not(:disabled,[aria-selected="true"]) path':
          props,
      };
    }
    case 'readonly':
      return {
        '&[readonly]': props,
        'input[role][readonly] ~ &': props,
        'input[role][readonly] ~ & path': props,
        '&.readonly input ~ &, &.readOnly input ~ &': props,
        '&.readonly input ~ & path, &.readOnly input ~ & path': props,
        '&.readonly, &.readOnly': props,
      };
    case 'selected':
      return {
        '&:selected': props,
        'input[role]:selected ~ &': props,
        'input[role]:selected ~ & path': props,
        '&[aria-selected="true"]': props,
      };
    default:
      return props as unknown as ThemeUICSSObject;
  }
};
export default buildStateObject;
